import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export async function getPECRList(payload) {
  try {
    const response = await privateClient.post('FetchPECRList', {
      ...payload,
    });
    return response.data;
  } catch (error) {
    console.error('Error inserting list filter:', error);
  }
}

export function createGetSiteListOptions(options) {
  return queryOptions({
    ...options,
    queryKey: ['site-list'],
    queryFn: () => getSiteList(),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getPECRAsOwner(payload) {
  try {
    const response = await privateClient.get('myPecrs/owner', {
      params: {
        ...payload,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PECR as owner:', error);
  }
}

export function createGetPECRAsOwnerOptions(payload, options) {
  return queryOptions({
    ...options,
    queryKey: ['pecr-as-owner', payload],
    queryFn: () => getPECRAsOwner(payload),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getPECRAsCreator(payload) {
  try {
    const response = await privateClient.get('myPecrs/creator', {
      params: {
        ...payload,
      },
    });
    return response.data;

  }catch(error) {
    console.error('Error fetching PECR as creator:', error);
  }
}

export function createGetPECRAsCreatorOptions(payload, options) {
  return queryOptions({
    ...options,
    queryKey: ['pecr-as-creator', payload],
    queryFn: () => getPECRAsCreator(payload),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getPECRAsActor(payload) {
  try {
    const response = await privateClient.get('myPecrs/actor', {
      params: {
        ...payload,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PECR as actor:', error);
  }
}

export function createGetPECRAsActorOptions(payload, options) {
  return queryOptions({
    ...options,
    queryKey: ['pecr-as-actor', payload],
    queryFn: () => getPECRAsActor(payload),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getSiteList() {
  const response = await privateClient.get('SiteList');
  return response.data;
}

export function createGetListStatusOptions(options) {
  return queryOptions({
    ...options,
    queryKey: ['list-status'],
    queryFn: () => getListStatus(),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getListStatus() {
  const response = await privateClient.get('FetchListStatus');
  return response.data;
}

async function getAllFilters(params) {
  const response = await privateClient.get(
    'userFilters?userId=' + params.userId
  );
  return response.data;
}

export function createGetAllFiltersOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['all-filters', params],
    queryFn: () => getAllFilters(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function insertFilter(params) {
  const response = await privateClient.post('InsertPECRFilter', {
    ...params,
  });
  return response.data;
}

export async function deleteFilter(params) {
  const response = await privateClient.post('DeletePECRFilter', {
    ...params,
  });
  return response.data;
}
